import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import Icon from "@ats/src/components/shared/Icon";

interface Props {
  children: React.ReactNode;
  onRemove?: () => void;
  removeLabel?: string;
}

const RemovableTag: React.FunctionComponent<Props> = ({ children, onRemove, removeLabel }) => {
  return (
    <Styled.Tag>
      <Styled.Label>{children}</Styled.Label>
      {onRemove && (
        <Styled.Remove
          type="button"
          onClick={onRemove}
          aria-label={removeLabel || "Remove"}
          title={removeLabel || "Remove"}
        >
          <Icon name="x" />
        </Styled.Remove>
      )}
    </Styled.Tag>
  );
};

export default RemovableTag;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Tag = styled.span((props: any) => {
  const t: any = props.theme;
  return css`
    label: RemovableTag;
    ${[t.text.sm, t.rounded.xs]}
    height: 1.625rem;
    padding-left: 9px;
    padding-right: ${t.spacing[1]};
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    gap: ${t.spacing[1]};
    max-width: 17.5rem;
    border: 1px solid transparent;
    background-color: ${t.dark ? t.color.gray[700] : t.color.gray[100]};
    color: ${t.dark ? t.color.gray[200] : t.color.black};
  `;
});

Styled.Label = styled.span`
  label: RemovableTag_Label;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

Styled.Remove = styled.button((props: any) => {
  const t: any = props.theme;
  return css`
    label: RemovableTag_Remove;
    ${t.rounded.xs}
    height: 1.25rem;
    width: 1.25rem;
    flex-shrink: 0;
    padding: 0;
    border: none;
    appearance: none;
    background: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    transition: background-color 0.2s ease, color 0.2s ease;

    svg {
      height: 0.875rem;
      width: 0.875rem;
    }

    &:hover {
      background-color: ${t.dark ? t.color.gray[600] : t.color.gray[200]};
      color: ${t.dark ? t.color.white : t.color.black};
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px ${t.dark ? t.color.gray[500] : t.color.gray[300]};
    }
  `;
});
